import { useAppDispatch, useAppSelector } from '../../../configuration/setup/hooks.ts';
import { togglePersonalCheckbox, useTermsAccepted } from '../../personal/personalInfoSlice.ts';
import { Checkbox } from '../../../components/Checkbox.tsx';
import type { PropsWithChildren } from 'react';
import { Region, regionSelector } from '../../region/regionSlice.ts';

export const TermsAcceptedCheckbox = (
    props: PropsWithChildren<{
        disabled?: boolean;
        className?: string;
        error?: string;
    }>
) => {
    const region = useAppSelector(regionSelector);

    const value = useTermsAccepted();
    const messageId = region === Region.latinamerica ? 'registration.personalData.gtcApprove.checkbox' : undefined;

    const dispatch = useAppDispatch();
    const onClick = () => dispatch(togglePersonalCheckbox('termsAccepted'));

    return (
        <Checkbox
            value={value}
            onClick={onClick}
            disabled={props.disabled}
            className={props.className}
            messageId={messageId}
            error={props.error}
        >
            {props.children}
        </Checkbox>
    );
};
